<tt-page *ngIf="!!edit">
    <tt-card class="col-xs-12 col-md-4 sp-0">
        <tt-chat [ttOptions]="chatOptions" (change)="submit.emit()"></tt-chat>
    </tt-card>
</tt-page>

<!--<tt-page class="col-xs-12 sp-0">
    <tt-card class="col-xs-12 col-md-4 sp-0">
        <tt-textarea class="col-xs-12 sp-0" tt-label="messagetext" tt-model="vm.model.edit.messagetext" tt-change="vm.model.edit.messagetext = $value" tt-readonly="false"></tt-textarea>
        <tt-button-save class="col-xs-12 sp-0" tt-text="orderdialog_add" tt-locked="vm.model.lockedAdd" tt-click="vm.addChanges()" tt-text-align="center"></tt-button-save>

        <div ng-repeat="comment in vm.model.commentListOrders">
            <br />
            <tt-message class="col-xs-12 sp-0" tt-label="{{comment.reg_datetime}}" tt-sublabel="{{comment.registered_by_name}}" tt-model="comment.messagetext" tt-change="comment.messagetext = $value" tt-is-current-user="comment.mymessage"></tt-message>
        </div>
    </tt-card>
</tt-page>-->
